import { CreateElement } from "vue";
import { DataModules } from "@/store/modules/data";
import { DefaultUsersFilters as UsersFilters } from "@/data/filters/users";
import { DefaultUsersSorters as UsersSorters } from "@/data/sorters/users";
import { IUser } from "@/models/users";
import { IImportMappingSource } from "@/models/imports";

const getUserRoute = (user: IUser) => {
  return {
    name: "adminUser",
    params: {
      userId: user.id
    }
  };
};

const firstLabel = (
  h: CreateElement,
  user: IUser,
  onClick: Function = () => ({})
) => {
  return h("p", {}, [
    h(
      "u-link",
      {
        props: { to: getUserRoute(user) },
        on: { click: onClick }
      },
      [h("strong", {}, user.name)]
    )
  ]);
};

const secondLabel = (h: CreateElement, user: IUser) => {
  return h("p", { class: "is-size-8" }, [
    h("span", { class: "has-text-grey-light" }, user.email || "--")
  ]);
};

const media = (h: CreateElement, user: IUser) => {
  return h("avatar", {
    props: {
      size: 48,
      name: user.fullname,
      src: user.image_url || null,
      email: user.email
    }
  });
};

export const UserSource: IImportMappingSource = {
  props: {
    availableFilters: UsersFilters,
    availableSorters: UsersSorters(),
    usedDataModule: DataModules.USERS,
    guardFunctionalities: [],
    storeParams: querySearch => {
      return {
        with: "image",
        with_staged_imports: 1,
        ...(querySearch ? { query: querySearch } : {})
      };
    }
  },
  render: {
    id: (user: IUser) => user.id,
    firstLabel: (h: CreateElement, user: IUser, onClick: Function) =>
      firstLabel(h, user, onClick),
    secondLabel: (h: CreateElement, user: IUser) => secondLabel(h, user),
    media: (h: CreateElement, user: IUser) => media(h, user)
  }
};
